// extracted by mini-css-extract-plugin
export default {"hero":"home_hero__fVly8","main":"home_main__rJ4ga","greeting":"home_greeting__l3Oks","animated-icon":"home_animated-icon__4P+EE","upDown":"home_upDown__mwd-Z"};